import { SeoSupport } from "../components/Public/SeoTdk";
import Layout from "../components/Public/Layout";
import styles from "./support.module.scss";
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Contact() {
  // tab1 - 表单数据
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [deviceType, setDeviceType] = useState();
  const [issueType, setIssueType] = useState();
  const [description, setDescription] = useState();

  // tab1 - 表单数据 校验
  const [nameEmptyError, setNameEmptyError] = useState();
  const [emailEmptyError, setEmailEmptyError] = useState();
  const [emailError, setEmailError] = useState();
  const [deviceTypeError, setDeviceTypeError] = useState();
  const [issueTypeError, setIssueTypeError] = useState();
  const [descEmptyError, setDescEmptyError] = useState();
  // tab1 - end

  // tab2 - 表单数据
  const [title, setTitle] = useState();
  const [detail, setDetail] = useState();

  // tab2 - 表单数据 校验
  const [titleEmptyError, setTitleEmptyError] = useState();
  const [detailEmptyError, setDetailEmptyError] = useState();
  const [currentTab, setCurrentTab] = useState(0);
  const [currentTypeLabel, setCurrentTypeLabel] = useState("");
  const [currentIssueLabel, setCurrentIssueLabel] = useState("");
  // tab2 - end

  const [isOpen, setIsOpen] = useState(false);
  const [flag, setFlag] = useState(false);
  const selectTypeRef = React.createRef();
  const selectIssueRef = React.createRef();

  const typeArr = [
    { value: "12", label: "iPhone 7p" },
    { value: "11", label: "iPhone 7" },
    { value: "10", label: "iPhone 6s" },
    { value: "9", label: "iPhone 6" },
    { value: "8", label: "iPhone 5S" },
    { value: "7", label: "iPhone 5C" },
    { value: "6", label: "iPhone 5" },
    { value: "5", label: "iPhone 4S" },
    { value: "4", label: "iPhone 4" },
    { value: "3", label: "iPhone 3GS" },
    { value: "2", label: "iPhone 3G" },
    { value: "1", label: "iPhone" },
    { value: "105", label: "iPad Mini" },
    { value: "104", label: "iPad 4" },
    { value: "103", label: "iPad 3" },
    { value: "102", label: "iPad 2" },
    { value: "101", label: "iPad" },
    { value: "201", label: "iPod Touch" },
    { value: "301", label: "Android Phone" },
    { value: "351", label: "Android Pad" },
    { value: "401", label: "Kindle Fire" },
    { value: "501", label: "Windows Phone" },
  ];
  const issueArr = [
    {
      value: "1",
      label: "Download Dingtone",
    },
    {
      value: "2",
      label: "Activation of Dingtone",
    },
    {
      value: "3",
      label: "Add friends",
    },
    {
      value: "4",
      label: "Connect to Facebook",
    },
    {
      value: "5",
      label: "Making a phone call",
    },
    {
      value: "6",
      label: "Group call",
    },
    {
      value: "7",
      label: "Send and receive SMS",
    },
    {
      value: "8",
      label: "Group messaging",
    },
    {
      value: "9",
      label: "Missing credits",
    },
  ];

  const handleTab = (id) => {
    return () => {
      setCurrentTab(id);
    };
  };
  const onTypeFocus = (type) => {
    return () => {
      if (type === 1) {
        selectTypeRef.current.style.display = "block";
      } else {
        selectIssueRef.current.style.display = "block";
      }
    };
  };
  const handleClick = (type, value, label) => {
    return () => {
      if (type === 1) {
        setDeviceType(value);
        setCurrentTypeLabel(label);
        setDeviceTypeError("");
        selectTypeRef.current.style.display = "none";
      } else {
        setIssueType(value);
        setCurrentIssueLabel(label);
        setIssueTypeError("");
        selectIssueRef.current.style.display = "none";
      }
    };
  };
  const handleInputChange = () => {
    console.log(`object`);
  };

  const toast = (time, text) => {
    let el = document.createElement("div");
    el.id = "toast";
    el.innerHTML = text;

    el.style.position = "fixed";
    el.style.top = "50%";
    el.style.left = "50%";
    el.style.padding = "15px";
    el.style.background = "rgba(0,0,0,0.68)";
    el.style.borderRadius = "8px";
    el.style.color = "#fff";
    el.style.transform = "translate(-50%,-50%)";

    document.getElementsByTagName("body")[0].appendChild(el);
    setTimeout(() => {
      document.getElementById("toast").remove();
    }, time);
  };

  const handleSubmit = (e) => {
    switch (e) {
      case 1:
        if (verify(1)) {
          let params =
            "username=" +
            encodeURIComponent(username) +
            "&email=" +
            encodeURIComponent(email) +
            "&deviceType=" +
            encodeURIComponent(deviceType) +
            "&issueType=" +
            encodeURIComponent(issueType) +
            "&description=" +
            encodeURIComponent(description) +
            "&referer=" +
            "";

          console.log(params);

          axios({
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            url: "/service/feedback",
            method: "post",
            data: params,
          })
            .then(function (response) {
              if (response.data.Result) {
                toast(2000, "Your issue report was submitted.");
              } else {
                toast(2000, response.data.Reason);
              }
            })
            .catch(function (error) {
              console.log(error);
              toast(2000, error);
            });
        }
        break;
      case 2:
        if (verify(2)) {
          let params =
            "title=" +
            encodeURIComponent(title) +
            "&detail=" +
            encodeURIComponent(detail) +
            "&referer=" +
            "";

          // console.log(params);

          axios({
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            url: "/service/suggestion",
            method: "post",
            data: params,
          })
            .then(function (response) {
              if (response.data.Result) {
                toast(2000, "Your idea was submitted");
              } else {
                toast(2000, response.data.Reason);
              }
            })
            .catch(function (error) {
              console.log(error);
              toast(2000, error);
            });
        }
        break;
      default:
        break;
    }
  };

  const verify = (params) => {
    switch (params) {
      case 1:
        let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        let flag = 0;
        if (!username) {
          setNameEmptyError("Your name is required.");
          flag++;
        } else {
          setNameEmptyError("");
        }

        if (!email) {
          setEmailError("");
          setEmailEmptyError("Your email is required.");
          flag++;
          console.log(0);
        } else if (!reg.test(email)) {
          setEmailEmptyError("");
          setEmailError("Invalid email address!");
          flag++;
          console.log(10);
        } else {
          setEmailError("");
        }

        if (!deviceType) {
          setDeviceTypeError("Device type is required.");
          flag++;
        } else {
          setDeviceTypeError("");
        }

        if (!issueType) {
          setIssueTypeError("Type of issue is required.");
          flag++;
        } else {
          setIssueTypeError("");
        }

        if (!description) {
          setDescEmptyError("Description is required.");
          flag++;
        } else {
          setDescEmptyError("");
        }

        if (flag) {
          return false;
        }
        return true;
      case 2:
        let flag1 = 0;
        if (!title) {
          setTitleEmptyError("Title is required.");
          flag1++;
        } else {
          setTitleEmptyError("");
        }

        if (!detail) {
          setDetailEmptyError("Detail is required.");
          flag1++;
        } else {
          setTitleEmptyError("");
        }
        if (flag1) {
          return false;
        }
        return true;
      default:
        break;
    }
  };

  const inputChange = (params) => {
    return (e) => {
      console.log(params, e.target.value);
      switch (params) {
        case "username":
          setUsername(e.target.value);
          if (e.target.value) {
            setNameEmptyError("");
          } else {
            setNameEmptyError("Your name is required.");
          }
          break;
        case "email":
          setEmail(e.target.value);

          let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
          setEmailError("");
          setEmailEmptyError("");

          if (e.target.value) {
            if (reg.test(e.target.value)) {
              setEmailEmptyError("");
            } else {
              setEmailError("Invalid email address!");
            }
          } else {
            setEmailEmptyError("Your email is required.");
          }

          break;
        case "description":
          setDescription(e.target.value);
          if (e.target.value) {
            setDescEmptyError("");
          } else {
            setDescEmptyError("Description is required.");
          }
          break;
        case "title":
          setTitle(e.target.value);
          if (e.target.value) {
            setTitleEmptyError("");
          } else {
            setTitleEmptyError("Title is required.");
          }
          break;
        case "detail":
          setDetail(e.target.value);
          if (e.target.value) {
            setDetailEmptyError("");
          } else {
            setDetailEmptyError("Detail is required.");
          }
          break;
        default:
          break;
      }
    };
  };

  const focusTip = () => {
    if (!flag) {
      setIsOpen(true);
      setFlag(true);
    }
  };
  useEffect(() => {
    return () => {};
  }, []);
  return (
    <div className="page">
      <SeoSupport />
      <Layout>
        <div className={styles.support}>
          <div className={styles.inner + " main"}>
            {/* <div>
              {username}-{email}-{deviceType}-{issueType}-{description}
            </div> */}
            <div className={styles.tab}>
              <span
                className={styles[currentTab === 0 ? "active" : ""]}
                onClick={handleTab(0)}
              >
                Report an lssue
              </span>
              <span
                className={styles[currentTab === 1 ? "active" : ""]}
                onClick={handleTab(1)}
              >
                Suggest an Idea
              </span>
            </div>

            <div className={styles.tips}>
              Please fill all fields as accurately as possible to make us
              quickly understand the issue you had with Dingtone.We may contact
              you by email if further information is needed. However,please
              understand that we may not be able to answer every issue that our
              users report.
            </div>

            <form>
              <div className={styles.part}>
                <div
                  className={styles.temp}
                  style={{
                    transform:
                      currentTab === 0 ? "translateX(0%)" : "translateX(-100%)",
                    height: currentTab === 0 ? "auto" : "0",
                  }}
                >
                  <div className={styles.item}>
                    <span>Your Name:</span>
                    <div className={styles.input}>
                      <input
                        style={{
                          outline: nameEmptyError ? "2px solid #ff3b30" : "",
                          background: nameEmptyError ? "#fff" : "",
                        }}
                        type="text"
                        onChange={inputChange("username")}
                        onFocus={focusTip}
                        id="tipInput"
                      />
                      <b>{nameEmptyError}</b>
                    </div>
                  </div>

                  <div className={styles.item}>
                    <span>Email Address:</span>
                    <div className={styles.input}>
                      <input
                        style={{
                          outline:
                            emailEmptyError || emailError
                              ? "2px solid #ff3b30"
                              : "",
                          background:
                            emailEmptyError || emailError ? "#fff" : "",
                        }}
                        type="text"
                        onChange={inputChange("email")}
                      />
                      <b>
                        {emailEmptyError}
                        {emailError}
                      </b>
                    </div>
                  </div>

                  <div className={styles.item}>
                    <span>Device Type:</span>
                    <div className={styles.select + " " + styles.input}>
                      <input
                        style={{
                          outline: deviceTypeError ? "2px solid #ff3b30" : "",
                          background: deviceTypeError ? "#fff" : "",
                        }}
                        type="text"
                        placeholder="Please select"
                        value={currentTypeLabel}
                        onChange={handleInputChange}
                        onFocus={onTypeFocus(1)}
                      />
                      <ul ref={selectTypeRef}>
                        {typeArr.map((item, index) => (
                          <li
                            value={item.value}
                            key={index}
                            onClick={handleClick(1, item.value, item.label)}
                          >
                            {item.label}
                          </li>
                        ))}
                      </ul>

                      <b>{deviceTypeError}</b>
                    </div>
                    <p>Select the device you are using</p>
                  </div>

                  <div className={styles.item}>
                    <span>Type of Issue:</span>
                    <div className={styles.select + " " + styles.input}>
                      <input
                        style={{
                          outline: issueTypeError ? "2px solid #ff3b30" : "",
                          background: issueTypeError ? "#fff" : "",
                        }}
                        type="text"
                        placeholder="Please select"
                        value={currentIssueLabel}
                        onChange={handleInputChange}
                        onFocus={onTypeFocus(2)}
                      />
                      <ul ref={selectIssueRef}>
                        {issueArr.map((item, index) => (
                          <li
                            value={item.value}
                            key={index}
                            onClick={handleClick(2, item.value, item.label)}
                          >
                            {item.label}
                          </li>
                        ))}
                      </ul>
                      <b>{issueTypeError}</b>
                    </div>
                    <p>
                      {`Select the issue that matches closest what you're experiencing`}
                    </p>
                  </div>

                  <div className={styles.item}>
                    <span>Description:</span>
                    <div
                      className={styles.input}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <textarea
                        style={{
                          outline: descEmptyError ? "2px solid #ff3b30" : "",
                          background: descEmptyError ? "#fff" : "",
                        }}
                        name="desc"
                        id="desc"
                        cols="30"
                        rows="10"
                        onChange={inputChange("description")}
                      ></textarea>
                      <b>{descEmptyError}</b>
                    </div>
                    <p>Please describe the problem as clearly as possible</p>
                  </div>

                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(1);
                    }}
                  >
                    Submit Support Case
                  </button>
                </div>

                <div
                  className={styles.temp}
                  style={{
                    transform:
                      currentTab === 1 ? "translateX(-100%)" : "translateX(0)",
                    height: currentTab === 1 ? "auto" : "0",
                  }}
                >
                  <div className={styles.item}>
                    <span>Your Idea:</span>
                    <div className={styles.input}>
                      <input
                        style={{
                          outline: titleEmptyError ? "2px solid #ff3b30" : "",
                          background: titleEmptyError ? "#fff" : "",
                        }}
                        type="text"
                        onChange={inputChange("title")}
                      />
                      <b>{titleEmptyError}</b>
                    </div>
                  </div>

                  <div className={styles.item}>
                    <span>Please describe your idea:</span>
                    <div
                      className={styles.input}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <textarea
                        style={{
                          outline: detailEmptyError ? "2px solid #ff3b30" : "",
                          background: detailEmptyError ? "#fff" : "",
                        }}
                        name="desc"
                        id="desc"
                        cols="30"
                        rows="10"
                        onChange={inputChange("detail")}
                      ></textarea>
                      <b>{detailEmptyError}</b>
                    </div>
                    <p>Please describe the problem as clearly as possible</p>
                  </div>

                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(2);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>

            <div
              className={styles.dialog}
              style={{ display: isOpen ? "block" : "none" }}
            >
              <div className={styles.dinner}>
                <h2>Important Information</h2>
                <p>
                  If you have already downloaded Dingtone to your device and you
                  can still open it, please open the app, enter{" "}
                  <span> “More”-&gt;Feedback or Report an Issue”</span>, and
                  describe what is happening.
                </p>

                <p>
                  This will send us useful diagnostic information that we can
                  use to quickly remedy any problems you may be having.
                </p>

                <button
                  onClick={() => {
                    setIsOpen(false);
                    document.getElementById("tipInput").focus();
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
